export default __webpack_public_path__ + "media/flags/is-093de0f4.svg";